import React, { useState } from "react";
import closeBtn from "../../assets/svg/free-icon-minimize-sign-6057365 2.svg";

const CoWorkers = ({ changeIsCoWorkersOpen }) => {
  const [number, setNumber] = useState("");
  const [family, setFamily] = useState("");
  const [livingState, setLivingState] = useState("");
  const [position, setPosition] = useState("");
  const [phone, setPhone] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [city, setCity] = useState("");
  const [vacantion, setVacantion] = useState("");
  const [author, setAuthor] = useState("");

  const handleSubmit = (e) => {};

  return (
    <div className="overlay">
      <div className="form-container coworkers">
        {/* Editable from here */}
        <h2 className="header">сотрудники</h2>
        <form onSubmit={handleSubmit}>
          {/* --- row1 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">#</label>
              <input
                type="text"
                placeholder="123456789"
                value={family}
                onChange={(e) => setNumber(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">ФИО</label>
              <input
                type="text"
                placeholder="Ивано Иван Иванович"
                value={family}
                onChange={(e) => setFamily(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row 2 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">Штат</label>
              <input
                type="text"
                placeholder="-----"
                value={livingState}
                onChange={(e) => setLivingState(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Должность</label>
              <input
                type="text"
                placeholder="Рабочий"
                value={position}
                onChange={(e) => setPosition(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row3 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">Телефон</label>
              <input
                type="phone"
                placeholder="+7 (999) 999-99-99"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Часовой пояс</label>
              <input
                type="text"
                placeholder="UTC+2"
                value={timeZone}
                onChange={(e) => setTimeZone(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row4 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">Дата рождения</label>
              <input
                type="date"
                placeholder="__.__.____"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Город</label>
              <input
                type="text"
                placeholder="Москва"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row5 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">Отпуск</label>
              <input
                type="date"
                placeholder="__.__.____"
                value={vacantion}
                onChange={(e) => setVacantion(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Автор строки</label>
              <input
                type="text"
                placeholder="-"
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                className="input"
              />
            </div>
          </div>
          <div className="">

          <button type="submit" className="btn popPasswordBtn">
            Подтвердить
          </button>
          </div>
        </form>

        <div className="closeForm">
          <button
            className="closePasswordFormBtn"
            onClick={changeIsCoWorkersOpen}
          >
            <img src={closeBtn} alt="CloseBtn" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoWorkers;
